module.exports = __webpack_public_path__ + "static/media/2.bb8c8218.jpg";